
export const uploadFileUrl = process.env.VUE_APP_BASE_API + '/resource/oss/upload'
